import React, { useState } from "react";
import islamabadMap from "../images/projects/islamabad_map.png";
import doha_arch from "../images/projects/doha_arch.png";
import { Helmet } from "react-helmet";

export default function DohaHeightsLandingPage() {
  const [showPaymentPlan, setShowPaymentPlan] = useState(false);
  const whatsappLink = "https://wa.me/923487172565";
  const amenities = [
    "Fully Gated Community",
    "24/7 Security With E-Tag Entry",
    "Multi-Purpose Sports Club",
    "Underground Electrification",
    "Underground Sui Gas",
    "200 Kanal Family Parks",
    "Graveyard",
    "Mini Golf Course",
    "Community Club",
    "Beautiful Theme Parks",
    "Glow Parks",
    "International Level Educational Institutes",
    "Jamia Masjids",
    "5000 Kanal Margalla Hills Surroundings",
    "Huge Underground Water Tanks",
    "Cinema & Community Clubs",
    "Luxury Living Experience",
  ];

  const towers = [
    {
      name: "Tower A",
      size: "100 x 70",
      sqft: "Luxury Residential Tower",
      image:
        "https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=1200&auto=format&fit=crop",
    },
    {
      name: "Tower B",
      size: "75 x 178",
      sqft: "Premium High-Rise Living",
      image:
        "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=1200&auto=format&fit=crop",
    },
    {
      name: "Tower C",
      size: "140 x 75",
      sqft: "Panoramic Margalla Views",
      image:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1200&auto=format&fit=crop",
    },
    {
      name: "Tower A",
      size: "100 x 70",
      sqft: "112,500 SQFT",
      image:
        "https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=1200&auto=format&fit=crop",
    },
    {
      name: "Tower B",
      size: "75 x 178",
      sqft: "270,000 SQFT",
      image:
        "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=1200&auto=format&fit=crop",
    },
    {
      name: "Tower C",
      size: "140 x 75",
      sqft: "300,000 SQFT",
      image:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1200&auto=format&fit=crop",
    },
  ];

  return (
    <div className="bg-[#f8f6f3] text-[#3b2c2a] overflow-hidden font-sans">
      <Helmet>
        <title>Doha Heights | EstateGhar</title>
        <meta
          name="description"
          content="Doha Heights - Luxury Residential Development in Islamabad"
        />
        <meta
          name="keywords"
          content="doha heights, luxury residential, projects in islamabad, real estate, property requests, buy property, rent property, real estate agents, property listings, EstateGhar"
        />
        <link
          rel="canonical"
          href="https://www.estateghar.com/projects/doha-heights"
        />
      </Helmet>
      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center px-6 lg:px-20">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=1600&auto=format&fit=crop"
            alt="Doha Heights"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#5d0b0f]/95 via-[#5d0b0f]/80 to-black/60" />
        </div>

        <div className="relative z-10 max-w-7xl w-full grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="border border-white/20 backdrop-blur-md bg-white/10 rounded-full px-5 py-2 inline-flex items-center gap-3 mb-8">
              <div className="w-2 h-2 rounded-full bg-white animate-pulse" />
              <span className="text-white tracking-[0.25em] text-xs uppercase">
                Luxury Living in Islamabad
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-light text-white leading-tight tracking-wide">
              Doha
              <span className="block font-semibold">Heights</span>
            </h1>

            <p className="mt-8 text-lg md:text-xl text-white/80 max-w-2xl leading-relaxed">
              A premium residential masterpiece by Doha Group and Faisal Town
              Pvt Ltd, inspired by modern architecture, breathtaking Margalla
              Hills views, and a luxurious lifestyle experience in the heart of
              Islamabad.
            </p>

            <div className="flex flex-wrap gap-5 mt-10">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white text-[#5d0b0f] rounded-full font-semibold hover:scale-105 transition-all duration-300 shadow-2xl inline-flex items-center justify-center"
              >
                Book Now
              </a>

              <button
                onClick={() => setShowPaymentPlan(true)}
                className="px-8 py-4 border border-white/40 text-white rounded-full backdrop-blur-md hover:bg-white/10 transition-all duration-300"
              >
                Payment Plan
              </button>
            </div>
          </div>

          <div className="relative hidden lg:flex justify-end">
            <div className="w-[420px] h-[580px] rounded-[40px] overflow-hidden border border-white/20 shadow-[0_30px_80px_rgba(0,0,0,0.45)] backdrop-blur-md">
              <img
                src="https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=1200&auto=format&fit=crop"
                alt="Building"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute -left-12 bottom-10 bg-white text-[#5d0b0f] rounded-3xl px-8 py-6 shadow-2xl">
              <p className="text-sm uppercase tracking-[0.2em] opacity-60">
                Prime Location
              </p>
              <h3 className="text-3xl font-bold mt-2">Faisal Hills</h3>
              <p className="mt-2 text-sm opacity-70">
                Adjacent to CDA Sector B-17
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-28 px-6 lg:px-20 bg-[#faf8f5]">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-20 items-center">
          <div className="relative">
            <div className="rounded-[40px] overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1200&auto=format&fit=crop"
                alt="Luxury Tower"
                className="w-full h-[650px] object-cover"
              />
            </div>

            <div className="absolute -bottom-10 -right-10 bg-[#5d0b0f] text-white p-10 rounded-[32px] max-w-xs shadow-2xl">
              <h3 className="text-5xl font-bold">50K</h3>
              <p className="mt-3 text-white/80 leading-relaxed">
                Kanal master-planned luxury development surrounded by the beauty
                of the Margalla Hills.
              </p>
            </div>
          </div>

          <div>
            <p className="uppercase tracking-[0.3em] text-[#9f6b5d] text-sm mb-5">
              Welcome to Doha Heights
            </p>

            <h2 className="text-5xl lg:text-6xl font-light leading-tight text-[#4c191c]">
              Redefining Modern
              <span className="block font-semibold">Luxury Living</span>
            </h2>

            <p className="mt-8 text-lg text-[#5e5553] leading-loose">
              Doha Heights is a premium vertical residential destination located
              in Faisal Hills — Islamabad’s rapidly growing luxury address.
              Developed by Faisal Town Pvt Ltd and Doha Group, the project spans
              within a 50,000 kanal master-planned community adjacent to CDA
              Sector B-17. Designed with elegant architecture, spacious layouts,
              scenic surroundings, smart infrastructure, and world-class
              amenities, Doha Heights delivers a refined urban lifestyle
              surrounded by the beauty of the Margalla Hills.
            </p>

            <div className="grid grid-cols-2 gap-5 mt-12">
              <div className="bg-white p-8 rounded-3xl shadow-xl border border-[#eee5df]">
                <h4 className="text-4xl font-bold text-[#5d0b0f]">225 ft</h4>
                <p className="mt-3 text-[#6b6461]">Main Boulevard Access</p>
              </div>

              <div className="bg-white p-8 rounded-3xl shadow-xl border border-[#eee5df]">
                <h4 className="text-4xl font-bold text-[#5d0b0f]">24/7</h4>
                <p className="mt-3 text-[#6b6461]">Security & Smart Access</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-28 px-6 lg:px-20 bg-[#5d0b0f] text-white relative overflow-hidden">
        <div className="">
          <h1 className="text-5xl lg:text-6xl my-10 font-light leading-tight text-center">
            Doha Architecture
          </h1>
          <img
            src={doha_arch}
            alt="Doha Architecture"
            className="w-full h-full rounded-lg object-cover"
          />
        </div>
      </section>

      {/* AMENITIES */}
      <section className="py-28 px-6 lg:px-20 bg-[#5d0b0f] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute w-[600px] h-[600px] rounded-full border border-white top-[-250px] right-[-200px]" />
          <div className="absolute w-[400px] h-[400px] rounded-full border border-white bottom-[-120px] left-[-100px]" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto">
            <p className="uppercase tracking-[0.35em] text-white/60 text-sm mb-5">
              Amenities & Facilities
            </p>

            <h2 className="text-5xl lg:text-6xl font-light leading-tight">
              Elevated Lifestyle
              <span className="block font-semibold">Experiences</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-20">
            {amenities.map((item, index) => (
              <div
                key={index}
                className="bg-white/10 border border-white/10 backdrop-blur-xl rounded-[28px] p-8 hover:bg-white/15 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center text-2xl mb-6">
                  ✦
                </div>
                <h3 className="text-lg font-medium leading-relaxed text-white/90">
                  {item}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TOWERS */}
      <section className="py-28 px-6 lg:px-20 bg-[#f8f6f3]">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
            <div>
              <p className="uppercase tracking-[0.3em] text-[#9f6b5d] text-sm mb-5">
                Towers Overview
              </p>

              <h2 className="text-5xl lg:text-6xl font-light text-[#4c191c] leading-tight">
                Signature
                <span className="block font-semibold">Residential Towers</span>
              </h2>
            </div>

            <p className="max-w-2xl text-lg text-[#645c5a] leading-loose">
              Every tower is carefully crafted with elegant facades, premium
              construction standards, optimized space planning, and panoramic
              city and mountain views.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 mt-20">
            {towers.map((tower, index) => (
              <div
                key={index}
                className="group bg-white rounded-[36px] overflow-hidden shadow-2xl border border-[#efe8e4]"
              >
                <div className="h-[420px] overflow-hidden">
                  <img
                    src={tower.image}
                    alt={tower.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>

                <div className="p-10">
                  <div className="flex items-center justify-between">
                    <h3 className="text-3xl font-semibold text-[#4c191c]">
                      {tower.name}
                    </h3>
                    <span className="bg-[#f6ece7] text-[#5d0b0f] px-4 py-2 rounded-full text-sm font-medium">
                      Premium
                    </span>
                  </div>

                  <div className="mt-8 space-y-5 text-[#5f5654]">
                    <div className="flex justify-between border-b border-[#f0ebe8] pb-4">
                      <span>Dimensions</span>
                      <span className="font-semibold text-[#4c191c]">
                        {tower.size}
                      </span>
                    </div>

                    <div className="flex justify-between border-b border-[#f0ebe8] pb-4">
                      <span>Total Cover Area</span>
                      <span className="font-semibold text-[#4c191c]">
                        {tower.sqft}
                      </span>
                    </div>
                  </div>

                  <a
                    href="https://wa.me/923487172565"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-10 w-full py-4 rounded-2xl bg-[#5d0b0f] text-white hover:opacity-90 transition-all duration-300 text-center inline-block"
                  >
                    Contact Sales Team
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LOCATION */}
      <section className="py-28 px-6 lg:px-20 bg-[#111111] text-white">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-20 items-center">
          <div>
            <p className="uppercase tracking-[0.35em] text-[#c78d80] text-sm mb-5">
              Prime Connectivity
            </p>

            <h2 className="text-5xl lg:text-6xl font-light leading-tight">
              Strategic
              <span className="block font-semibold">Islamabad Location</span>
            </h2>

            <div className="space-y-6 mt-12 text-lg text-white/75">
              <div className="flex items-center justify-between border-b border-white/10 pb-5">
                <span>Adjacent to CDA Sector B-17</span>
                <span>Prime Islamabad Access</span>
              </div>
              <div className="flex items-center justify-between border-b border-white/10 pb-5">
                <span>F-10 Sector</span>
                <span>15 Min Distance</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/10 pb-5">
                <span>Multi Zoo</span>
                <span>5 Min Distance</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/10 pb-5">
                <span>Khanpur Dam</span>
                <span>45 Min Distance</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/10 pb-5">
                <span>Motorway M1</span>
                <span>Direct Access</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/10 pb-5">
                <span>Downtown Faisal Hills</span>
                <span>Main Boulevard 225 ft</span>
              </div>
            </div>
          </div>

          <div className="relative rounded-[40px] overflow-hidden border border-white/10 shadow-2xl">
            <img
              src={islamabadMap}
              alt="Map"
              className="w-full h-[650px] object-cover"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

            <div className="absolute bottom-8 left-8 right-8 bg-white/10 backdrop-blur-xl border border-white/10 rounded-3xl p-8">
              <h3 className="text-3xl font-semibold">Faisal Hills Map</h3>
              <p className="mt-3 text-white/70 leading-relaxed">
                Perfectly connected to Islamabad, Taxila, and the surrounding
                urban network with breathtaking Margalla Hills scenery.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-32 px-6 lg:px-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1600&auto=format&fit=crop"
            alt="Luxury"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#4d080d]/85" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto text-center text-white">
          <p className="uppercase tracking-[0.35em] text-white/60 text-sm mb-5">
            Book Your Luxury Lifestyle
          </p>

          <h2 className="text-5xl lg:text-7xl font-light leading-tight">
            Experience Doha Heights
            <span className="block font-semibold">Like Never Before</span>
          </h2>

          <p className="mt-8 text-xl text-white/75 leading-loose max-w-3xl mx-auto">
            Discover sophisticated architecture, premium amenities, breathtaking
            landscapes, and an elevated residential experience in the heart of
            Faisal Hills Islamabad.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mt-12">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-5 bg-white text-[#5d0b0f] rounded-full font-semibold hover:scale-105 transition-all duration-300 shadow-2xl inline-flex items-center justify-center"
            >
              Schedule Visit
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-5 border border-white/20 rounded-full backdrop-blur-md hover:bg-white/10 transition-all duration-300 inline-flex items-center justify-center"
            >
              Contact Sales Team
            </a>
          </div>
        </div>
      </section>

      {showPaymentPlan && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-6">
          <div className="bg-[#faf8f5] rounded-[40px] w-full max-w-6xl max-h-[95vh] overflow-y-auto shadow-[0_30px_100px_rgba(0,0,0,0.5)] relative">
            <button
              onClick={() => setShowPaymentPlan(false)}
              className="absolute top-6 right-6 z-20 w-12 h-12 rounded-full bg-[#5d0b0f] text-white text-2xl"
            >
              ×
            </button>

            <div className="bg-[#5d0b0f] text-white px-10 py-16">
              <p className="uppercase tracking-[0.35em] text-white/60 text-sm mb-4">
                Doha Heights Faisal Hills
              </p>
              <h2 className="text-5xl font-light leading-tight">
                Apartment
                <span className="block font-semibold">Payment Plan</span>
              </h2>
              <p className="mt-6 text-white/75 text-lg leading-loose max-w-3xl">
                Plot no 07 Apartments, Main Boulevard, Block A, Faisal Hills,
                Adjacent to Margalla Hills Sector B-17 Islamabad.
              </p>
            </div>

            <div className="p-10 space-y-10">
              <div className="bg-white rounded-[32px] border border-[#eee3dd] overflow-hidden shadow-xl">
                <div className="bg-[#f6ece7] px-8 py-6">
                  <h3 className="text-3xl font-semibold text-[#4c191c]">
                    2-Bed Apartment • 1250 Sq.ft
                  </h3>
                  <p className="text-[#6a5b58] mt-2">
                    Includes 01 Car Parking • 5 Marla
                  </p>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full min-w-[900px]">
                    <thead>
                      <tr className="text-left border-b border-[#eee3dd] text-[#4c191c]">
                        <th className="px-8 py-5">Category</th>
                        <th className="px-8 py-5">Total Price</th>
                        <th className="px-8 py-5">Down Payment</th>
                        <th className="px-8 py-5">Monthly x60</th>
                        <th className="px-8 py-5">Possession</th>
                      </tr>
                    </thead>
                    <tbody className="text-[#5f5654]">
                      <tr className="border-b border-[#f5ece8]">
                        <td className="px-8 py-6 font-semibold">Standard</td>
                        <td className="px-8 py-6">1,56,00,000</td>
                        <td className="px-8 py-6">40,00,000</td>
                        <td className="px-8 py-6">1,80,000</td>
                        <td className="px-8 py-6">8,00,000</td>
                      </tr>
                      <tr className="border-b border-[#f5ece8]">
                        <td className="px-8 py-6 font-semibold">Corner</td>
                        <td className="px-8 py-6">1,70,00,000</td>
                        <td className="px-8 py-6">45,00,000</td>
                        <td className="px-8 py-6">1,95,000</td>
                        <td className="px-8 py-6">8,00,000</td>
                      </tr>
                      <tr>
                        <td className="px-8 py-6 font-semibold">
                          Corner With Terrace
                        </td>
                        <td className="px-8 py-6">1,80,00,000</td>
                        <td className="px-8 py-6">50,00,000</td>
                        <td className="px-8 py-6">2,00,000</td>
                        <td className="px-8 py-6">10,00,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="bg-white rounded-[32px] border border-[#eee3dd] overflow-hidden shadow-xl">
                <div className="bg-[#f6ece7] px-8 py-6">
                  <h3 className="text-3xl font-semibold text-[#4c191c]">
                    1-Bed Apartment • 650 Sq.ft
                  </h3>
                  <p className="text-[#6a5b58] mt-2">Compact Luxury Living</p>
                </div>

                <div className="overflow-x-auto">
                  <table className="w-full min-w-[900px]">
                    <thead>
                      <tr className="text-left border-b border-[#eee3dd] text-[#4c191c]">
                        <th className="px-8 py-5">Category</th>
                        <th className="px-8 py-5">Total Price</th>
                        <th className="px-8 py-5">Down Payment</th>
                        <th className="px-8 py-5">Monthly x60</th>
                        <th className="px-8 py-5">Possession</th>
                      </tr>
                    </thead>
                    <tbody className="text-[#5f5654]">
                      <tr>
                        <td className="px-8 py-6 font-semibold">Compact</td>
                        <td className="px-8 py-6">75,00,000</td>
                        <td className="px-8 py-6">20,00,000</td>
                        <td className="px-8 py-6">85,000</td>
                        <td className="px-8 py-6">4,00,000</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="bg-[#5d0b0f] rounded-[32px] p-10 text-white flex flex-col lg:flex-row items-center justify-between gap-8">
                <div>
                  <p className="uppercase tracking-[0.3em] text-white/60 text-sm mb-3">
                    Pre Launching Rates
                  </p>
                  <h3 className="text-4xl font-semibold">
                    Rs. 12,500 per Sq.ft
                  </h3>
                  <p className="mt-4 text-white/75 leading-loose max-w-2xl">
                    Management reserves the right to change the price list at
                    any time.
                  </p>
                </div>

                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-10 py-5 bg-white text-[#5d0b0f] rounded-full font-semibold"
                >
                  Book Apartment Now
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
